require('/opt/odin/app/frontend/components/offers/stamp/index.module.scss');module.exports = "../../app/cells/components/offers/stamp/show.erb";